import { getAxiosInstance } from '../client';
/** Typed API functions for offices */
export const officesQueries = {
    /** GET /offices/:id */
    getById: (officeId) => getAxiosInstance()
        .get(`/offices/${officeId}`)
        .then((r) => r.data),
    /** GET /offices/:officeId/patients */
    getPatientsByOffice: (officeId) => getAxiosInstance()
        .get(`/offices/${officeId}/patients`)
        .then((r) => r.data),
    /** GET /offices/:officeId/patienten.csv - Download CSV export */
    exportPatientsCsv: async (officeId) => {
        const response = await getAxiosInstance().get(`/offices/${officeId}/patienten.csv`, {
            responseType: 'blob',
        });
        return response.data;
    },
    /** GET /offices/stats */
    getGlobalStats: () => getAxiosInstance()
        .get('offices/stats')
        .then((r) => r.data),
    /** GET /offices/stats/:officeId */
    getStats: (officeId) => getAxiosInstance()
        .get(`offices/stats/${officeId}`)
        .then((r) => r.data),
};
/** Query keys for offices - use with TanStack Query */
export const officesKeys = {
    all: () => ['offices'],
    byId: (officeId) => ['offices', officeId],
    patients: (officeId) => ['offices', officeId, 'patients'],
    globalStats: () => ['offices', 'stats'],
    stats: (officeId) => ['offices', 'stats', officeId],
};
//# sourceMappingURL=offices.queries.js.map